import './PreventiveIssueCreate.scss';

import { useViolationsCreateForm } from "../../../hooks/useViolationsCreateForm";
import { useGetViolationsFieldOptions } from "../../../hooks/useGetViolationFieldOptions";

import { Field } from "../../../common-components/Field/Field";

const PreventiveIssueCreate = ({id}) => {
    const { formId, adaptedFieldList } = useViolationsCreateForm({id});

    useGetViolationsFieldOptions();

    return (
        <div className={"preventive-issue-create"}>
            <div className={"preventive-issue-create_container"}>
                <div className={"preventive-issue-create_form"}>
                    {adaptedFieldList.map((category) => (
                        <div className={"preventive-issue-create_form-category"}>
                            <div className={"preventive-issue-create_form-category_title"}>
                                {category.category}
                                <div className={"preventive-issue-create_form-category_attention"}>
                                    {category.categoryAttention}
                                </div>
                            </div>
                            <div className={"preventive-issue-create_form-category_items"}>
                                {category.fields.map((field) => (
                                    <Field
                                        key={field.name}
                                        label={field.label}
                                        name={field.name}
                                        propertyLabel={field.label}
                                        options={field.options}
                                        formId={formId}
                                        type={field.type}
                                        validationRules={field.validationRules}
                                        fieldStructure={field.fieldStructure}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default PreventiveIssueCreate;